import Alpine from 'alpinejs'
window.Alpine = Alpine

export const init = () => {
    return new Promise((resolve) => {
        Alpine.store('navOpen', {
            on: false,
            activeSubMenu: 1,
            searchOpen: false,
            toggle() {
                this.on = !this.on
            },
            toggleSearch() {
                this.searchOpen = !this.searchOpen
            },
        })
        return resolve('')
    })
}
